import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import {
	Service,
	ServiceDetail,
	ServiceQueryParams,
	SERVICE_STATUS,
	SERVICE_TYPES,
} from "../types.d";
import { languages } from "constants/constants";

interface ServiceState {
	serviceList: Service[];
	serviceTotal: number;
	loading: boolean;
	serviceDetail: ServiceDetail;
}

export const serviceDefault: ServiceDetail = {
	id: 0,
	currency: "usd",
	price: 0,
	period: "",
	cover: "",
	order: 1,
	category: null,
	type: SERVICE_TYPES.CUSTOMER,
	status: SERVICE_STATUS.ENABLED,
	photos: [],
	translations: languages.map(el => ({
		name: "",
		description: "",
		language: el.key,
	})),
};

const initialState: ServiceState = {
	serviceList: [],
	serviceTotal: 0,
	loading: false,
	serviceDetail: serviceDefault,
};

export const serviceSlice = createSlice({
	name: "service",
	initialState,
	reducers: {
		setListService: (state, action) => {
			state.serviceList = action.payload.data;
			state.serviceTotal = action.payload.total;
		},
		setDetailService: (state, action) => {
			state.serviceDetail = {
				...action.payload.data,
				photos: action.payload.data.photos.map((el: { url: string }) => el.url),
			};
		},
		changeStatusService: (state, action) => {
			const { id, status } = action.payload;
			const index = state.serviceList.findIndex(el => el.id === id);
			state.serviceList[index].status = status;
		},
		setLoadingService:(state, action) =>{
			state.loading = action.payload;
		},
		resetServiceDetail: (state) => {
			state.serviceDetail = initialState.serviceDetail;
		}
	},
});

export const selectServiceList = (state: RootState) =>
	state.service.serviceList;
export const selectServiceTotal = (state: RootState) =>
	state.service.serviceTotal;
export const selectServiceDetail = (state: RootState) =>
	state.service.serviceDetail;
export const selectLoadingService = (state: RootState) =>
	state.service.loading;

export const { setListService, setDetailService, changeStatusService, setLoadingService, resetServiceDetail } =
	serviceSlice.actions;

export interface GetListServiceAsyncPayload {
  query: ServiceQueryParams;
	callback?: () => void;
}
export const getListServiceAsync = createAction(
	"service/getListServiceAsync",
	(payload: GetListServiceAsyncPayload) => ({
		payload: payload,
	}),
);

export interface GetDetailServiceAsyncPayload {
	id: number;
	callback?: () => void;
}
export const getDetailServiceAsync = createAction(
	"service/getDetailServiceAsync",
	(payload: GetDetailServiceAsyncPayload) => ({
		payload,
	}),
);

export interface CreateServiceAsyncPayload {
	data: ServiceDetail;
	returnSuccessStatus: (status: boolean) => void;
}
export const createServiceAsync = createAction(
	"service/createServiceAsync",
	(payload: CreateServiceAsyncPayload) => ({
		payload,
	}),
);

export interface UpdateServiceAsyncPayload {
	id: number;
	data: ServiceDetail;
}
export const updateServiceAsync = createAction(
	"service/updateServiceAsync",
	(payload: UpdateServiceAsyncPayload) => ({
		payload,
	}),
);

export interface UpdateStatusServiceAsyncPayload {
	id: number;
	status: SERVICE_STATUS;
	callback?: () => void;
}
export const updateStatusServiceAsync = createAction(
	"service/updateStatusServiceAsync",
	(payload: UpdateStatusServiceAsyncPayload) => ({
		payload,
	}),
);

export default serviceSlice.reducer;
